module.exports = __webpack_public_path__ + "images/europcar_small3d3d5d7072640cf845bada7669b553d1.png";